




function scrollDownAnimationDeskItems() {


    if (jQuery(".js-scrlto-m7").length) {

        var linkScrollClick = ".js-scrlto-m7";

        jQuery(document).on('click', linkScrollClick , function(event) {


            jQuery('html, body').animate({
                scrollTop: jQuery( jQuery(this).attr('scrollsec') ).offset().top - 30
            }, 800);

            return false;
        });
    }
};






export {scrollDownAnimationDeskItems};
